import { linkGeneric } from '../../../utils/shiftnative/utils';
import groupingLinkTypeSelectors from '../../../utils/shiftnative/subaruLinkTypeSelectors';
import groupingLocationSelectors from '../../../utils/shiftnative/subaruLocationSelectors';

export default {
	events: {
		'ddc.link.generic': [
			{
				payload: ({ element, eventData }) => {
					return linkGeneric({
						element,
						eventData,
						groupingLinkTypeSelectors,
						groupingLocationSelectors
					});
				}
			}
		]
	}
};
